import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button} from 'views/components';
import {translate} from 'views/module';
import SubscribeUserDialog
  from 'views/scenes/client/detail/client_scenes/client_feed/relationships/contacts/dialogs/SubscribeUserDialog';

import {convertToE164} from 'utils/miscellaneous/e164';

const CaregiverDialpadIntegration = (props) => {
  const {
    caregiverBackend,
    phoneNumber,
    caregiverDialpadIntegration,
    caregiverDialpadIntegrationLoading,
    statusProgressWrap: progressWrap,
  } = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [smsNumber, setSmsNumber] = React.useState(phoneNumber ?? '');

  React.useEffect(() => {
    setSmsNumber(phoneNumber);
  }, [phoneNumber]);

  React.useEffect(() => {
    if (caregiverDialpadIntegration !== undefined || caregiverDialpadIntegrationLoading) {
      return;
    }

    caregiverBackend.dialpadIntegration.getCaregiverDialpadLink();
  }, [caregiverBackend, caregiverDialpadIntegration, caregiverDialpadIntegrationLoading]);

  const createCaregiverDialpadLink = async (smsNumber) => {
    setIsLoading(true);
    await progressWrap(async () => {
      try {
        const conversion = convertToE164(smsNumber, ['CA', 'US']);
        if (!conversion.isValid) {
          throw new Error(conversion.reasonNotValid || 'Invalid phone number');
        }
        const e164FormattedNumber = conversion.e164Format;
        await caregiverBackend.dialpadIntegration.createCaregiverDialpadLink(
            e164FormattedNumber,
            () => setIsLoading(false),
        );
      } finally {
        setIsLoading(false);
      }
    });
  };

  const handleSubmitSmsNumber = (input) => {
    createCaregiverDialpadLink(input);
    setShowDialog(false);
  };

  const handleOpenDialog = () => {
    setSmsNumber(smsNumber.trim());
    setShowDialog(true);
  };

  const getButtonConfig = () => {
    if (caregiverDialpadIntegration?.phoneNumber) {
      return {
        text: translate('client.ClientDetail.Relationships.Contacts.States.Active'),
        action: () => {/* no deactivation api right now */},
      };
    } else {
      return {
        text: translate('client.ClientDetail.Relationships.Contacts.States.Setup'),
        action: handleOpenDialog,
      };
    }
  };

  const buttonConfig = getButtonConfig();
  const isDialpadLoading = isLoading || caregiverDialpadIntegrationLoading || caregiverDialpadIntegration === undefined;

  return (
    <>
      <Button
        onClick={buttonConfig.action}
        variant='contained'
        size='small'
        disabled={isDialpadLoading}
        sx={{color: 'color.white'}}
      >
        {buttonConfig.text}
      </Button>
      {
        showDialog &&
        <SubscribeUserDialog
          open={showDialog}
          onClose={() => {
            setShowDialog(false);
          }}
          onSubmit={handleSubmitSmsNumber}
          initialChannelValue={smsNumber}
          isLoading={isLoading}
          channelType='Sms'
          channel='Dialpad'
          errorMessage={translate('client.ClientDetail.Relationships.Contacts.Dialogs.SmsHelperText.FailRegexMessage')}
          regex={/^\+?1?\s*(?:\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}$/}
        />
      }
    </>
  );
};

CaregiverDialpadIntegration.propTypes = {
  caregiverBackend: PropTypes.object.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  caregiverDialpadIntegration: PropTypes.object,
  caregiverDialpadIntegrationLoading: PropTypes.bool.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, dispatch)(React.memo(CaregiverDialpadIntegration));
